<div class="progress-loader" [hidden]="!isloading" >
    <div class="loading-spinner">
        <img src="../../../assets/images/Bay6_LoadingAnimation_V1.gif" width="65" height="65">
        <span class="loading-message"></span>
    </div>
</div>